const AMC_MAPPING: Record<string, string> = {
  // KFin codes (numeric)
  '128': 'Axis Mutual Fund',
  '178': 'Baroda BNP Paribas Mutual Fund',
  '116': 'BOI AXA Mutual Fund',
  '101': 'Canara Robeco Mutual Fund',
  '118': 'Edelweiss Mutual Fund',
  '125': 'Groww Mutual Fund',
  '120': 'Invesco Mutual Fund',
  '152': 'ITI Mutual Fund',
  '105': 'JM Financial Mutual Fund',
  '102': 'LIC Mutual Fund',
  '117': 'Mirae Asset Mutual Fund',
  '127': 'Motilal Oswal Mutual Fund',
  RMF: 'Nippon India Mutual Fund',
  '129': 'PGIM India Mutual Fund',
  '166': 'Quant Mutual Fund',
  '123': 'Quantum Mutual Fund',
  '176': 'Sundaram Mutual Fund',
  '104': 'Taurus Mutual Fund',
  '108': 'UTI Mutual Fund',
  '185': 'Trust Mutual Fund',
  '188': 'Samco Mutual Fund',
  '187': 'NJ Mutual Fund',
  '189': 'Bajaj Finserv Mutual Fund',
  IDFC: 'Bandhan Mutual Fund',
  SBI: 'SBI Mutual Fund',
  ICIC: 'ICICI Prudential Mutual Fund',
  HDFC: 'HDFC Mutual Fund',
  PPFAS: 'PPFAS Mutual Fund',
  KOT: 'Kotak Mutual Fund',
  TATA: 'TATA Mutual Fund',
  HSBC: 'HSBC Mutual Fund',
  FT: 'Franklin Templeton Mutual Fund',
  DSP: 'DSP Mutual Fund',
  PLF: 'Navi Mutual Fund',
  WO: 'WhiteOak Capital Mutual Fund',
  AB: 'Aditya Birla Sun Life Mutual Fund',
  SHR: 'Shriram Mutual Fund',
  MAHINDRA: 'Mahindra Manulife Mutual Fund',
  UNION: 'Union Mutual Fund',
  IIFL: 'IIFL Mutual Fund',
};

export interface AMCMapping {
  amcName: string;
  logoName: string;
}
 
export const getAMCFromMaskedAccountNumber = (
  maskedAccountNumber: string
): AMCMapping | null => {
  if (!maskedAccountNumber) return null;

  const accountUpper = maskedAccountNumber.toUpperCase();
  const codeBeforeHyphen = accountUpper.split('-')[0];

  if (AMC_MAPPING[codeBeforeHyphen]) {
    const amcName = AMC_MAPPING[codeBeforeHyphen];
    return {
      amcName,
      logoName: amcName.replace(/ /g, '_'),
    };
  }

  return null;
};

export const getAMCLogoUrl = (logoName: string): string => {
  return `https://logo.ignosis.ai/fund/${logoName}.png`;
};


export const getMaskedAccountDisplay = (maskedAccountNumber: string): string => {
  if (!maskedAccountNumber) return '****';
  return maskedAccountNumber.slice(-4);
};
